import { GlobalController } from 'src/shared/global/GlobalController'
import Structure from './Structure'
const ifAuthenticated = (to, from, next) => {
  GlobalController.getAsyncInstance().then(data => {
    if (data && data.authResp && data.authResp.token) {
      next()
    } else {
      next('/')
    }
  })
}
export const routes = [
  {
    path: ':link',
    name: 'structure',
    component: Structure,
    beforeEnter: ifAuthenticated,
    props: true
  }
]
